import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BestAvailableModel, PriceTypeQuantity, WheelchairActivityType } from "../interfaces/types";

const initialState: BestAvailableModel = (window as any).bestAvailableModel ? (window as any).bestAvailableModel : null;

const bestAvailableModelSlice = createSlice({
    name: 'best-available-model-slice',
    initialState,
    reducers: {
        updatePriceTypeQuantities: (state, action: PayloadAction<PriceTypeQuantity>) => {
            // If the price type is already in the list, update the price type
            if (state.priceTypeQuantities.filter(pt => pt.priceTypeId === action.payload.priceTypeId && pt.zoneId === action.payload.zoneId).length > 0) {
                let newPtQuantityState = state.priceTypeQuantities.map(priceType => {
                    if (priceType.priceTypeId === action.payload.priceTypeId && priceType.zoneId === action.payload.zoneId) {
                        return action.payload
                    }
                    else {
                        return priceType;
                    }
                });

                let newState = { ...state };
                newState.priceTypeQuantities = newPtQuantityState;

                return state = newState;
            }
        },
        updateBestAvailableModel: (state, action: PayloadAction<BestAvailableModel>) => {
            return state = action.payload;
        },
        updateActivityTypes: (state, action: PayloadAction<WheelchairActivityType>) => {
            if (state.activityTypes.filter(act => act.activityTypeId === action.payload.activityTypeId).length > 0) {
                let newActivityTypesState = state.activityTypes.map(act => {
                    if (act.activityTypeId === action.payload.activityTypeId) {
                        return action.payload
                    } else {
                        const newActivity: WheelchairActivityType = {
                            activityTypeDescription: act.activityTypeDescription,
                            activityTypeId: act.activityTypeId,
                            isSelected: false
                        };
                        return newActivity;
                    }
                })

                let newState = { ...state };
                newState.activityTypes = newActivityTypesState;

                return state = newState;
            }
        },
        updateShowWheelchairActivityType: (state, action: PayloadAction<boolean>) => {
            let newState = { ...state };
            newState.showWheelchairActivityTypes = action.payload;

            return state = newState;
        },
        updateShowWheelchairModal: (state, action: PayloadAction<boolean>) => {
            let newState = { ...state };
            newState.showWheelchairModal = action.payload;

            return state = newState;
        },
        updateSelectedZone: (state, action: PayloadAction<number>) => {
            let newState = { ...state };
            newState.selectedZoneId = action.payload;

            return state = newState;
        },
    },
})

export default bestAvailableModelSlice;